import { runtimeEndpoints } from './runtime-endpoints';
export const ENDPOINTS=runtimeEndpoints(window.location.hostname,{
 control:import.meta.env.VITE_CONTROL_API_URL,installer:import.meta.env.VITE_INSTALL_HOST,
});
